if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						console.log("remove clicked");
						
						this.updateCartQty(item, 0);
					
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));

					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}



			})

		}



		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {	
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;


					// cart drawer assembly service js

						let estimateShippingBtn = document.querySelector('.js-estimate-shipping');
						const cartWrapper = document.querySelector('#site-cart-sidebar .cart-form');
						const mainCartWrapper = document.querySelector('.template-cart .cart-section');

						console.log(cartWrapper);
						console.log(mainCartWrapper);

						// if (!cartWrapper || !mainCartWrapper) return;

						console.log("after if");	

						const checkEligibilityInLocalStorage = () => {
						const eligibility = localStorage.getItem('eligibility');
						return eligibility?.toLowerCase() === 'true' ? true
							: eligibility?.toLowerCase() === 'false' ? false
							: null;
						};

						console.log(checkEligibilityInLocalStorage() , "eligibility componentcartjs");
						
					
					const toggleAssemblyInCart = (isEligible) => {

						if (cartWrapper) cartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
						if (mainCartWrapper) mainCartWrapper.classList.toggle('hide_assembly_variants', !isEligible);

						// Get main wrappers (safely)
						const mainCartDrawerWrapper = cartWrapper?.querySelector(".cart__items");
						const mainCartPageWrapper = mainCartWrapper?.querySelector(".cart-form__items");

						let hasAssemblyMessage = false; 

						// --- Process main cart page items ---
						if (document.body.classList.contains("template-cart") && mainCartPageWrapper) {
							const itemWrappers = mainCartPageWrapper.querySelectorAll('.cart-form-item');

							itemWrappers.forEach(wrapper => {
								const title = (wrapper.dataset.title || "").toLowerCase();

								if (title.includes("assembly services")) {
									if (!isEligible) {
										if (!wrapper.querySelector('.assembly-service-msg')) {
											const msg = document.createElement('p');
											msg.className = 'assembly-service-msg';
											msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
											wrapper.appendChild(msg);
										}
										hasAssemblyMessage = true;
									} else {
										const existingMsg = wrapper.querySelector('.assembly-service-msg');
										if (existingMsg) existingMsg.remove();
									}
								}
							});

							console.log(hasAssemblyMessage , "hasAssemblyMessage component_cart_js cart page" );
							
						}
						

						// --- Process cart drawer items ---
						if (!document.body.classList.contains("template-cart") && mainCartDrawerWrapper) {
							const itemWrappers = mainCartDrawerWrapper.querySelectorAll('.itg_cart_item_wrapper');

							itemWrappers.forEach(wrapper => {
								const cartItem = wrapper.querySelector('.cart-item');
								if (!cartItem) return;

								const title = (cartItem.dataset.title || "").toLowerCase();

								if (title.includes("assembly services")) {
									if (!isEligible) {
										if (!wrapper.querySelector('.assembly-service-msg')) {
											const msg = document.createElement('p');
											msg.className = 'assembly-service-msg';
											// msg.textContent = "It is no longer valid for the updated location";
											msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
											wrapper.appendChild(msg);
										}
										hasAssemblyMessage = true;
									} else {
										const existingMsg = wrapper.querySelector('.assembly-service-msg');
										if (existingMsg) existingMsg.remove();
									}
								}
							});

							console.log(hasAssemblyMessage , "hasAssemblyMessageInCartDrawer component_cart_js" );

						}
						

						// --- Disable all checkout buttons if needed ---
						const checkoutBtns = document.querySelectorAll('button#CheckOut');
						checkoutBtns.forEach(btn => {
							btn.disabled = hasAssemblyMessage;
							btn.style.opacity = hasAssemblyMessage ? 0.5 : 1;
							btn.style.pointerEvents = hasAssemblyMessage ? 'none' : 'auto';
						});

					};

					setTimeout(() => {
						toggleAssemblyInCart(checkEligibilityInLocalStorage());
					}, 1000);

					// cart drawer assembly service js
					

					// cart update progress bar

						let storedCartPrice = parseFloat(localStorage.getItem('loadedCartPrice')) || 0;

						console.log('Stored cart price from localStorage:', storedCartPrice);

						console.log("Cart successfully updated");

						const subTotalElem = document.getElementById('AjaxCartSubtotal');
						if (!subTotalElem) return;

						let subTotalAmt = subTotalElem.querySelector('.cart__total')?.getAttribute("data-total-price");
						if (!subTotalAmt) return;

					

						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());
						console.log(isNaN(cartPrice), "cartPrice", cartPrice);

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						console.log(subTotalAmt);

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

						const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							console.log(cart , "cart_data") ;
							

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;


							// New Final allSteps Code For Free Product 

							// allSteps.forEach((step, index) => {
							// 	const stepAmount = parseFloat(step.getAttribute("data-amount"));
							// 	if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

							// 	step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

							// 	const productElem = step.querySelector(".product_or_discount");
							// 	if (!productElem) return;

							// 	const type = productElem.getAttribute("data-product-or-discount");
							// 	const productVariantId = productElem.getAttribute("data-product-id");
							// 	const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

							// 	// -----------------------------
							// 	// IF (cartPrice >= stepAmount)
							// 	// -----------------------------
							// 	if (cartPrice >= stepAmount && type === "product") {

							// 		const hasFreeItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) === 0;
							// 		});

							// 		const hasPaidItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) > 0;
							// 		});

							// 		console.log(hasFreeItem, "hasFreeItem (price=0)");
							// 		console.log(hasPaidItem, "hasPaidItem (price>0)");

							// 		// Rule: DO NOT render if a free version already exists
							// 		const shouldRender = !hasFreeItem;

							// 		if (shouldRender) {
							// 			allProductsHTML += `
							// 				<div class="single_step_product_wrapper" id="${wrapperId}">
							// 					<div class="free_product_wrapper_inner">
							// 						${productElem.innerHTML}
							// 					</div>
							// 				</div>`;
							// 		}
							// 	}

							// 	// -----------------------------
							// 	// ELSE (cartPrice < stepAmount)
							// 	// -----------------------------
							// 	else {

							// 		// 1. Remove accordion
							// 		const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
							// 		if (mainAccordion) {
							// 			const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
							// 			if (productWrapper) productWrapper.remove();
							// 		}

							// 		// 2. Remove ONLY free version from cart
							// 		if (type === "product") {

							// 			// Find all matched items
							// 			const matchedItems = cart.items.filter(item => {
							// 				const id = item.id.toString().replace("item-", "");
							// 				return id === productVariantId.toString();
							// 			});

							// 			console.log(matchedItems , "matchedItems in else part") ;

							// 			matchedItems.forEach(item => {

							// 				console.log(item.price , "each item Price in else");
											
							// 				const price = Number(item.price);
							// 				if (price === 0) {
							// 					console.log("Removing free item:", item.id);
							// 					removeProductFromCart(productVariantId);
							// 				} else {
							// 					console.log("Keeping paid item:", item.id);
							// 				}
							// 			});
							// 		}
							// 	}
							// });

							allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const productVariantId = productElem.getAttribute("data-product-id");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // -----------------------------
                                // IF (cartPrice >= stepAmount)
                                // -----------------------------

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    const hasPaidItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) > 0;
                                    });

                                    console.log(hasFreeItem, "hasFreeItem (price=0)");
                                    console.log(hasPaidItem, "hasPaidItem (price>0)");

                                    // If ANY variant exists → do NOT render
                                    // const shouldRender = !hasFreeItem && !hasPaidItem;
                                    const shouldRender = !hasFreeItem;

                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }


                                else {

                                        // 1. Remove accordion HTML
                                        const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                        if (mainAccordion) {
                                            const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                            if (productWrapper) productWrapper.remove();
                                        }

                                        // 2. Remove only free variant from cart
                                        if (type === "product") {

                                            const matchedItems = cart.items.filter(item => {
                                                return item.product_id.toString() === productIdOnly.toString();
                                            });
                                            

                                            matchedItems.forEach(item => {
                                                if (Number(item.price) === 0) {
                                                    console.log("Removing free item:", item.variant_id);
                                                    removeProductFromCart(item.variant_id);
                                                } else {
                                                    console.log("Keeping paid variant:", item.variant_id);
                                                }
                                            });
                                        }
                                    }

                                });


							let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');

							let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

							if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
								const cartItemsWrapper = document.querySelector('.cart-form__items');
								if (cartItemsWrapper) {
									cartPageWrapper = document.createElement('div');
									cartPageWrapper.classList.add('sidebar__free_product_wrapper');
									cartItemsWrapper.appendChild(cartPageWrapper);

										if (allProductsHTML.trim() !== '') {
											const wrapper = document.createElement('div');
											wrapper.classList.add('main_free_product_accordion_wrapper');
											wrapper.innerHTML = `
												<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
													<span class="productTitleItg">Free Gift</span>
													<span class="svg-wrapper accordion_down_icon">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
															<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
														</svg>
													</span>
												</div>
												<div class="free_product_wrapper" style="display:block;">
													<div class="free_product_inner_container">
														${allProductsHTML}
													</div>
												</div>
											`;

											// Toggle accordion
											wrapper.querySelector('.headerItg').addEventListener('click', () => {
												const content = wrapper.querySelector('.free_product_wrapper');
												content.style.display = content.style.display === 'block' ? 'none' : 'block';
											});

											cartPageWrapper.appendChild(wrapper);
										} else {
											cartPageWrapper.classList.add('hideWrapper');
										}
									
									}
								}else{
									let sidebarWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');
									if (sidebarWrapper) {
										sidebarWrapper.innerHTML = '';
									}
								}       


							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}

						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">Free Gift</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}

						})();



						// Filled bar
						if (!isNaN(cartPrice)) {
							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);

							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";

							}
						
						}

						// subtotalAmt Updated

						console.log(subTotalAmt);

						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);


					// removeProductFromCart  function //

					async function removeProductFromCart(productVariantId) {
						try {
							const lineItemElem = document.querySelector(`#item-${productVariantId}`);

							if (lineItemElem) {
								const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

								if (removeBtn) {
									removeBtn.click(); // trigger click on the remove button
									console.log(`Clicked remove for variant ${productVariantId}`);

									// await updateCartDrawer() ;

								} else {
									console.warn(`Remove button not found for variant ${productVariantId}`);
								}
							} else {
								console.warn(`Line item not found in DOM for variant ${productVariantId}`);
							}
						} catch (err) {
							console.error(`Error removing variant ${productVariantId}:`, err);
						}
					}	

					// cart update progress bar
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {
				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');

				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add('processing');
						this.discountCodes.classList.add('processing');

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove('processing');
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove('processing');
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains('enabled') ) {
						elm.classList.add('enabled');
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add('processing');
							this.discountCodes.classList.add('processing');
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove('processing');
				this.discountCodes.classList.remove('processing');
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}